// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/icon/style/index.less
// module id = 89
// module chunks = 0